import React from "react";
import Hero from "@/components/Hero";
import HomeSections from "@/components/HomeSections";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0a1f3d]">
      <Hero />
      <HomeSections />
      <Footer />
    </div>
  );
}
